import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import MainStore from './../MainStore';
import { observer } from "mobx-react"
import styled from 'styled-components';
import CustomButton from './Button';
import DialogCloseButton from './DialogCloseButton';
import { useTranslation } from 'react-i18next';

const AlertDialog = observer(() => {
  const { t } = useTranslation();
  const translate = t;

  return (
    <Dialog onClose={MainStore.onCloseAlert}
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth={'sm'}
      open={MainStore.alert.messages.length > 0}
    >
      <DialogCloseButton id="AlertDialogCloseButton" onClick={MainStore.onCloseAlert} />
      <ContentWrapper>
        <Header >
          <MainText>{MainStore.alert.titles[0]}</MainText>
        </Header>
        <Body>
          <div dangerouslySetInnerHTML={{ __html: MainStore.alert.messages[0] }} />
        </Body>

        <ButtonWrapper>
          <CustomButton
            name="AlertButtonYes"
            color="primary"
            variant="contained"
            onClick={MainStore.onCloseAlert}>
            {translate('ok')}
          </CustomButton>
        </ButtonWrapper>
      </ContentWrapper>
    </Dialog>
  );
})

export default AlertDialog


const MainText = styled.h1`
  margin: 20px;
`


const ButtonWrapper = styled.div`
  margin: 10px;
  margin-left: 30px
`
const ContentWrapper = styled(MuiDialogContent)`
  margin: 20px;
`
const Header = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 36px;
  text-align: left;
  color: var(--colorNeutralForeground1);
  margin: 0 0 30px 0;
`;

const Body = styled.div`
  margin: 30px;
`;
// Крестик закрытия — общий DialogCloseButton (та же разметка лежала копиями
// в AlertDialog, NotSavedDialog, ConfirmDialog и DigitalSignDialog).
